module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Icon/email-9b9289a7efb34119a23de1709981f830.svg";